'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import ViverseButton from '@/components/ViverseButton';
import { UseFollowDataFnType } from '@/hooks/useFollowData';
import { PublicFollowingWithIcon } from '@/services/community';
type FollowButtonProps = UseFollowDataFnType & {
  following: PublicFollowingWithIcon;
};
function FollowButton(t0) {
  const $ = _c(7);
  const {
    following,
    checkIfFollowing,
    handleRefollow,
    handleUnfollow
  } = t0;
  const t = useTranslations();
  const [isButtonEnabled, setIsButtonEnabled] = useState(true);
  let t1;
  if ($[0] !== checkIfFollowing || $[1] !== following || $[2] !== handleRefollow || $[3] !== handleUnfollow || $[4] !== isButtonEnabled || $[5] !== t) {
    t1 = <>{!checkIfFollowing(following.preferredUsername) ? <ViverseButton size="fit" variant="default" className="px-[20px] py-[4px]" onClick={async () => {
        setIsButtonEnabled(false);
        await handleRefollow(following);
        setIsButtonEnabled(true);
      }} disabled={!isButtonEnabled}>{t("profile-page.intro-follow-action")}</ViverseButton> : <ViverseButton size="fit" variant="secondary" className="px-[20px] py-[4px]" onClick={async () => {
        setIsButtonEnabled(false);
        await handleUnfollow(following);
        setIsButtonEnabled(true);
      }} disabled={!isButtonEnabled}>{t("profile-page.intro-unfollow-action")}</ViverseButton>}</>;
    $[0] = checkIfFollowing;
    $[1] = following;
    $[2] = handleRefollow;
    $[3] = handleUnfollow;
    $[4] = isButtonEnabled;
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}
export default FollowButton;